<template>
  <header class="header" style="z-index:200">
    <div class="header-block header-block-collapse d-lg-none d-xl-none">
      <button class="collapse-btn" id="sidebar-collapse-btn" @click="openMenu()">
        <font-awesome-icon icon="bars" />
      </button>
    </div>

    <div class="header-block header-block-nav">
      <ul class="nav-profile d-flex align-items-center">
        <li v-if="(isAdmin || isSuperAdmin) && runningSystemJobs.length > 0" class="mr-4">
          <font-awesome-icon icon="cog" spin style="color: white" class="mr-1" />
          <b-badge variant="">{{ runningSystemJobs[0].description }}</b-badge>
        </li>
        <li v-if="isAdmin || isSuperAdmin">
          <b-dropdown class="jobs-pending" v-if="pendingJobs.length > 0">
            <template v-slot:button-content>
              <b-badge variant="secondary">{{ pendingJobs.length }}</b-badge>
            </template>
            <b-dropdown-item v-for="job in pendingJobs" :key="job.id">
              {{ job.description }}
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown class="jobs-running" v-if="runningJobs.length > 0">
            <template v-slot:button-content>
              <b-badge variant="warning">{{ runningJobs.length }}</b-badge>
            </template>
            <b-dropdown-item v-for="job in runningJobs" :key="job.id">
              {{ job.description }}
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown class="jobs-completed" v-if="completedJobs.length > 0">
            <template v-slot:button-content>
              <b-badge variant="success">{{ completedJobs.length }}</b-badge>
            </template>
            <b-dropdown-item v-for="job in completedJobs" :key="job.id">
              <div class="job-item">
                <span>{{ job.description }}</span>
                <b-badge variant="danger" @click="setJobRead(job.id)">
                  <font-awesome-icon icon="times" />
                </b-badge>
              </div>
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown class="jobs-error" v-if="errorJobs.length > 0">
            <template v-slot:button-content>
              <b-badge variant="danger">{{ errorJobs.length }}</b-badge>
            </template>
            <b-dropdown-item v-for="job in errorJobs" :key="job.id">
              <span>{{ job.description }}</span>
              <b-badge variant="danger" @click="setJobRead(job.id)">
                <font-awesome-icon icon="times" />
              </b-badge>
            </b-dropdown-item>
          </b-dropdown>
        </li>
        <li v-if="importingGmail">
          <font-awesome-icon icon="arrows-rotate" fade style="color: white" class="mr-1" />
          <font-awesome-icon icon="envelope" fade style="color: white" class="mr-2" />
        </li>
        <!--<li>
          <router-link to="/alarms" class="d-flex align-items-center">
            <font-awesome-icon v-if="alarms" icon="circle" class="alarm-red" />
            <font-awesome-icon v-else icon="circle" class="alarm-green" />
          </router-link>
        </li>-->

        <li v-if="isAdmin || isSuperAdmin">
          <b-dropdown class="admin-menu">
            <template v-slot:button-content>
              <img class="top-bar-icon" src="/static/icons/icon-10.png" alt="Amministrazione" />
            </template>

            <b-dropdown-item to="/customers" v-if="isSuperAdmin">
              <font-awesome-icon icon="address-card" class="mr-2" /> Clienti
            </b-dropdown-item>

            <b-dropdown-item to="/sites">
              <font-awesome-icon icon="industry" class="mr-2" /> Siti
            </b-dropdown-item>

            <b-dropdown-item to="/users" v-if="!isDemo">
              <font-awesome-icon icon="users" class="mr-2" /> Utenti
            </b-dropdown-item>

            <b-dropdown-item to="/export-data" v-if="isSuperAdmin">
              <font-awesome-icon icon="download" class="mr-2" /> Esporta dati
            </b-dropdown-item>

            <b-dropdown-item to="/indicators">
              <font-awesome-icon icon="chart-line" class="mr-2" /> Indicatori
            </b-dropdown-item>

            <b-dropdown-item to="/blackbox/rules" v-if="isSuperAdmin">
              <font-awesome-icon icon="hard-drive" class="mr-2" /> Regole BlackBox
            </b-dropdown-item>

            <b-dropdown-item to="/import-logs">
              <font-awesome-icon icon="database" class="mr-2" /> Importazioni
            </b-dropdown-item>

            <b-dropdown-item to="/co-suppliers">
              <font-awesome-icon icon="plug" class="mr-2" /> Fornitori
            </b-dropdown-item>

            <b-dropdown-item to="/alarms">
              <font-awesome-icon icon="bell" class="mr-2" /> Allarmi
            </b-dropdown-item>

            <b-dropdown-item to="/measure-types" v-if="isSuperAdmin">
              <font-awesome-icon icon="ruler-horizontal" class="mr-2" /> Codici misure
            </b-dropdown-item>

            <b-dropdown-item @click="importation()" v-if="isSuperAdmin">
              <font-awesome-icon icon="envelope" class="mr-2" /> Avvia importazione GMail
            </b-dropdown-item>

            <b-dropdown-item to="/logs" v-if="isSuperAdmin">
              <font-awesome-icon icon="list" class="mr-2" /> Log
            </b-dropdown-item>
          </b-dropdown>
        </li>
        <li v-if="isSuperAdmin || isAdmin">
          <router-link to="/upload" class="btn">
            <img class="top-bar-icon" src="/static/icons/icon-9.png" alt="Upload" />
          </router-link>
        </li>
        <li>
          <a class="btn" v-on:click="logout()">
            <img class="top-bar-icon" src="/static/icons/icon-8.png" alt="Logout" />
          </a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import api from '@/services/api';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'TopBar',
  data() {
    return {
      alarms: false,
      importingGmail: false,
    }
  },

  created() {
    this.loadNotification();
    this.poll();
    //setInterval(this.loadNotification, 60000);
    //setInterval(this.poll, 10000);

    this.listenSystemJobs();
    //setInterval(this.pollSystemJobs, 1000);
  },
  computed: {
    ...mapState({
      jobs: state => state.jobs.jobs,
      systemJobs: state => state.jobs.systemJobs
    }),
    ...mapGetters({
      pendingJobs: 'jobs/getPendingJobs',
      runningJobs: 'jobs/getRunningJobs',
      completedJobs: 'jobs/getCompletedJobs',
      errorJobs: 'jobs/getErrorJobs',
      runningSystemJobs: 'jobs/getRunningSystemJobs'
    }),
    user() { return this.$store.state.user.name },
    isAdmin() {
      return this.$store.state.user && this.$store.state.user.level == 2
    },
    isSuperAdmin() {
      return this.$store.state.user && this.$store.state.user.level == 1
    },
    isDemo() {
      return this.$store.state.user && this.$store.state.user.altCustomerName
    }
  },
  methods: {
    ...mapActions({
      poll: 'jobs/poll',
      listenSystemJobs: 'jobs/listenSystemJobs'
    }),
    async importation() {
      await api().get('/gmail/import');
      this.importingGmail = true;
      this.$notify({
        type: "success",
        title: 'Importazione avviata'
      });
      this.loadNotification();
    },
    async setJobRead(id) {
      this.$store.dispatch('jobs/setJobRead', id);
    },
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
    },
    openMenu() {
      this.$store.commit('openMenu')
    },
    loadNotification() {
      api().get('/customer/notifications').then(data => {
        this.alarms = data.data.data.activeAlerts;
        this.importingGmail = data.data.data.importingGmail;
      });
    }
  },
}
</script>

<style>
.nav-profile .job-item .badge {
  opacity: 0;
}

.nav-profile li:hover .job-item .badge {
  opacity: 1;
}

.nav-profile .btn.btn-secondary {
  border: 0;
}

.alarm-red {
  vertical-align: middle;
  color: red;
  font-size: 15px;
}

.alarm-green {
  vertical-align: middle;
  color: green;
  font-size: 15px;
}

.top-bar-icon {
  width: 32px;
}

.nav-profile .btn-group.b-dropdown.dropdown.admin-menu button {
  border: 0 !important;
  padding: 0 6px;
}

.nav-profile .btn-group.b-dropdown.dropdown.admin-menu button:active {
  background: transparent;
}

.nav-profile .btn-group.b-dropdown.dropdown.admin-menu button:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.nav-profile .btn-group.b-dropdown.dropdown.admin-menu button:after {
  display: none;
}
.header .header-block-nav>ul>li:before {
  display: none;
}

.header .header-block-nav .dropdown-menu {
  background: #0D1011;
  margin-top: 13px;
}

.header .header-block-nav a {
  color: #CACBC7;
}

.nav-profile .btn-group.b-dropdown.dropdown a:hover,
.nav-profile .btn-group.b-dropdown.dropdown .active {
  background: #333;
  color: #fff;
}

.nav-profile .dropdown-menu .dropdown-item {
  padding-top: 10px;
  padding-bottom: 10px;
}
.nav-profile .job-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/TopBar.vue